import React from 'react';
import { Container } from '../components/Container';
import { EmailIcon } from '../icons/Email';
import { PhoneIcon } from '../icons/Phone';
import { FooterProps } from './Footer';

const socialMedias = [
  ['Mastodon', 'https://social.partiarazem.pl/@razem'],
  ['Twitter', 'https://twitter.com/partiarazem'],
  ['Facebook', 'https://www.facebook.com/partiarazem'],
  ['YouTube', 'https://www.youtube.com/c/PartiaRazemPL'],
  ['Instagram', 'https://www.instagram.com/partiarazem/'],
];

const pages = [
  ['Program (PL)', '/deklaracja-programowa'],
  ['Join us (PL)', 'https://dolacz.partiarazem.pl'],
  ['About us (PL)', '/struktura'],
  ['Privacy policy (PL)', '/polityka-prywatnosci'],
  ['News (PL)', '/aktualnosci'],
  ['Wersja polska 🇵🇱', '/', 'pl'],
  ['Українська версія 🇺🇦', '/home-ua', 'uk'],
];

export const FooterEn: React.FC<FooterProps> = () => (
  <footer>
    <Container>
      <footer className="footer">
        <ul className="footer__social">
          {socialMedias.map(([label, url]) => (
            <li key={url}>
              <a
                href={url}
                target="_blank"
                // eslint-disable-next-line react/no-invalid-html-attribute
                rel="me noreferrer noopener"
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
        <section className="footer__contact">
          <h2>Contact</h2>
          <address itemScope itemType="https://schema.org/Organization">
            <a href="mailto:kontakt@partiarazem.pl">
              <EmailIcon />
              {' '}
              kontakt@partiarazem.pl
            </a>
            <a href="tel:+48663483923">
              <PhoneIcon />
              {' '}
              +48663483923
            </a>
            <div
              className="footer__contact__street"
              itemProp="address"
              itemScope
              itemType="https://schema.org/PostalAddress"
            >
              <span itemProp="streetAddress">Nowy Świat 27</span>
              ,
              {' '}
              <span itemProp="postalCode">00-029</span>
              {' '}
              <span itemProp="addressLocality">Warszawa</span>
            </div>
          </address>
        </section>
        <section className="footer__pages">
          <h2>Pages</h2>
          <ul>
            {pages.map(([label, url, lang = 'en']) => (
              <li key={url}>
                <a
                  href={url}
                  target={url.startsWith('http') ? '_blank' : undefined}
                  rel="noopener noreferrer"
                  lang={lang}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </section>
      </footer>
    </Container>
  </footer>
);
